import { APColumn, APFormFieldCheckbox, APFormFieldDropdown, APFormFieldFile, APFormFieldImage, APFormFieldText, APIcon, APOtp, APPalette, APRow, APSizedBox, APText, APTypography, convertBase64, getIt, JourneyStepApp, showAlertSnackBarConfirmation, showErrorDialog, showSnackbar } from 'ap-components';
import React, { useState } from 'react'
import { EmpanelmentData } from '.';
import EmpanelmentService from '../../Services/EmpanelmentService';
import MasterTables from '../../Models/MasterTables';




export default function PersonalDetails({ empanelmentData, updateEmpanelmentData }: { empanelmentData: Partial<EmpanelmentData>, updateEmpanelmentData: (data: Partial<EmpanelmentData>) => void }): JourneyStepApp {
    const [form] = useState({
        arn: empanelmentData.arn ?? '',
        euin: empanelmentData.euin ?? '',
        euinData: '',
        nomineeName: '',
        nomineeRelationship: ''
    });
    const [includeNominee, setIncludeNominee] = useState(true);

    return ({
        title: "Personal Details",
        code: 'Personal Details',
        description: "Next: Bank Details",
        form: ((
            <APColumn mainAxisAlignment='center' crossAxisAlignment='stretch' mainAxisSize='max'>
                <APText style={APTypography.h1}> Personal Details</APText>
                <APText style={APTypography['paragraph-medium']}>Verify your details as per official records.</APText>
                <APSizedBox width="16px" />
                <APFormFieldText
                    disabled={true}
                    label='ARN'
                    initialValue={empanelmentData.arn}
                    helperText="As per AMFI records"
                />
                <APFormFieldText
                    disabled={true}
                    label='Name'
                    initialValue={empanelmentData.name}
                    helperText="As per AMFI records"
                />
                {
                    !empanelmentData.euin || empanelmentData.euin === "" ?
                        <APColumn crossAxisAlignment="stretch">
                            <APFormFieldText

                                label='EUIN'
                                textAppearance="uppercase"
                                onChanged={(v) => form.euin = v}
                                validator={(v) => {
                                    var regex = /^[E][0-9]{6}$/gm;
                                    if (v.length == 0) {
                                        return "Please enter EUIN";
                                    }
                                    if (!regex.test(v)) {
                                        return 'Invalid EUIN'
                                    }
                                    return null
                                }}
                            />
                            <APSizedBox height='8px' />
                            <APFormFieldImage
                                label="EUIN Proof"
                                onChange={(src) => {
                                    form.euinData = src ?? '';
                                }}
                                validator={(src) => {
                                    if (!src || src.length === 0) {
                                        return "EUIN Proof required";
                                    }
                                    return null;
                                }}
                            />
                        </APColumn>
                        :
                        <APFormFieldText
                            disabled
                            helperText="As per AMFI records"
                            label="EUIN"
                            value={empanelmentData.euin}
                        />
                }
                <div style={{ backgroundColor: APPalette["grey-200"], width: "100%", height: '2px', margin: '8px 6px 8px 2px' }}></div>
                <APText
                    variant='paragraph-large'
                    style={{ marginLeft: "2px", fontWeight: 400, fontSize: "16px", lineHeight: "24px" }}
                >
                    Add Nominee
                </APText>

                    <APFormFieldText
                        keyboardType='text'
                        maxLength={50}
                        required
                        label="Nominee name"
                        onChanged={v => {
                            form.nomineeName = v
                        }}
                        validator={v => {
                            if (!/^[a-zA-Z\s]*$/.test(v)) {
                                return "Special characters not allowed";
                            }
                            if (v.trim().length === 0) {
                                return "Please enter Nominee Name";
                            }
                            if (v.trim().length < 2) {
                                return "Please enter Nominee Name"
                            }
                            return null;
                        }}
                    />
                    <APFormFieldDropdown
                        required
                        label="Nominee relationship"
                        items={MasterTables.NomineeRelation.map(e => ({ label: e, value: e }))}
                        onChanged={v => {
                            if (v) {
                                form.nomineeRelationship = v;
                            }
                        }}
                        validator={v => {
                            if (!v) {
                                return "Please select Nominee Relationship";
                            }
                            return null;
                        }}
                    />

            </APColumn >
        )),
        onSubmit: async () => {
            await getIt(EmpanelmentService).savePersonalDetails({ ...form, euin: empanelmentData.euin || form.euin, nomineeName: form.nomineeName.trim() });
        }
    });
}

